import {
  ADD_ITADMIN_UNASSIGNED_DATA,
  UPDATE_ITADMIN_FETCH_UNASSIGNED_DATA_INPROGRESS,
  ADD_ITADMIN_ASSIGNED_DATA,
  UPDATE_ITADMIN_FETCH_ASSIGNED_DATA_INPROGRESS,
  UPDATE_ITADMIN_FETCH_COMPLETE_STATE_INPROGRESS,
  ADD_ITADMIN_QC_CASES_DATA,
  UPDATE_ITADMIN_FETCH_QC_DATA_INPROGRESS,
  ADD_ITADMIN_COMPLETE_DATA,
  ADD_ITADMIN_SETTINGS_DATA,
  ADD_ITADMIN_STATE_DATA,
  UPDATE_ITADMIN_FETCH_COMPLETE_DATA_INPROGRESS,
  DELETE_SETTING_ERROR,
  DELETE_SETTING_SUCCESS,
  ADD_SETTING_ERROR,
  ADD_SETTING_SUCCESS,
  ADD_STATE_ERROR,
  ADD_STATE_SUCCESS,
  DELETE_STATE_SUCCESS,
  DELETE_STATE_ERROR,
  ADD_DUPLICATE_SETTING,
  EDIT_SETTING_ERROR,
  EDIT_SETTING_SUCCESS,
  EDIT_STATE_ERROR,
  EDIT_STATE_SUCCESS,
} from '../../../actions'

export const getITAdminUnassignedDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_ITADMIN_UNASSIGNED_DATA:
      return { ...state, ...action.payload }

    case UPDATE_ITADMIN_FETCH_UNASSIGNED_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getITAdminAssignedDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_ITADMIN_ASSIGNED_DATA:
      return { ...state, ...action.payload }
    case UPDATE_ITADMIN_FETCH_ASSIGNED_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getITAdminQCCasesDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_ITADMIN_QC_CASES_DATA:
      return { ...state, ...action.payload }
    case UPDATE_ITADMIN_FETCH_QC_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getITAdminCompleteDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_ITADMIN_COMPLETE_DATA:
      return { ...state, ...action.payload }
    case UPDATE_ITADMIN_FETCH_COMPLETE_DATA_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

export const getITAdminSettingsDataReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_ITADMIN_SETTINGS_DATA:
      return { ...action.payload }

    default:
      return state
  }
}

const deleteSetting = {
  re_procedure_code_success: false,
  re_procedure_code_error: false,
}

export const deleteSettingResponseReducer = (state = deleteSetting, action) => {
  switch (action.type) {
    case DELETE_SETTING_SUCCESS:
      return { ...state, re_procedure_code_success: true, re_procedure_code_error: false }
    case DELETE_SETTING_ERROR:
      return { ...state, re_procedure_code_success: false, re_procedure_code_error: true }

    default:
      return state
  }
}
const addSetting = {
  add_procedure_code_success: false,
  add_procedure_code_error: false,
  add_duplicate_procedure_code: false,
}

export const addSettingResponseReducer = (state = addSetting, action) => {
  switch (action.type) {
    case ADD_SETTING_SUCCESS:
      return {
        ...state,
        add_procedure_code_success: true,
        add_procedure_code_error: false,
        add_duplicate_procedure_code: false,
      }
    case ADD_SETTING_ERROR:
      return {
        ...state,
        add_procedure_code_success: false,
        add_procedure_code_error: true,
        add_duplicate_procedure_code: false,
      }
    case ADD_DUPLICATE_SETTING:
      return {
        ...state,
        add_procedure_code_success: false,
        add_procedure_code_error: false,
        add_duplicate_procedure_code: true,
      }
    default:
      return state
  }
}
const editSetting = {
  edit_procedure_code_success: false,
  edit_procedure_code_error: false,
}

export const editSettingResponseReducer = (state = editSetting, action) => {
  switch (action.type) {
    case EDIT_SETTING_SUCCESS:
      return { ...state, edit_procedure_code_success: true, edit_procedure_code_error: false }
    case EDIT_SETTING_ERROR:
      return { ...state, edit_procedure_code_success: false, edit_procedure_code_error: true }

    default:
      return state
  }
}
export const getITAdminStateDataReducer = (state = { fetchInProgress: false }, action) => {
  switch (action.type) {
    case ADD_ITADMIN_STATE_DATA:
      return { ...action.payload }
    case UPDATE_ITADMIN_FETCH_COMPLETE_STATE_INPROGRESS:
      return { ...state, fetchInProgress: action.inProgress }
    default:
      return state
  }
}

const addStateSetting = {
  add_state_success: false,
  add_state_error: false,
}
export const addStateResponseReducer = (state = addStateSetting, action) => {
  switch (action.type) {
    case ADD_STATE_SUCCESS:
      return {
        ...state,
        add_state_success: true,
        add_state_error: false,
      }
    case ADD_STATE_ERROR:
      return {
        ...state,
        add_state_success: false,
        add_state_error: true,
      }
    default:
      return state
  }
}

const editState = {
  edit_state_success: false,
  edit_state_error: false,
}

export const editStateResponseReducer = (state = editState, action) => {
  switch (action.type) {
    case EDIT_STATE_SUCCESS:
      return { ...state, edit_state_success: true, edit_procedure_code_error: false }
    case EDIT_STATE_ERROR:
      return { ...state, edit_state_success: false, edit_state_error: true }

    default:
      return state
  }
}

const deleteState = {
  delete_state_success: false,
  delete_state_error: false,
}

export const deleteStateResponseReducer = (state = deleteState, action) => {
  switch (action.type) {
    case DELETE_STATE_SUCCESS:
      return { ...state, delete_state_success: true, delete_state_error: false }
    case DELETE_STATE_ERROR:
      return { ...state, delete_state_success: false, delete_state_error: true }

    default:
      return state
  }
}
